<template>
  <div>
    <!--Sort, Grid - List icons -->
    <div class="flex md:w-1/4 lg:w-1/4 flex-row md:float-right lg:float-right">
      <div
        class="bg-white hover:bg-gray-100 text-gray-800 font-bold rounded inline-flex items-center mx-auto"
      >
        <el-select v-model="value" placeholder="Sortieren nach">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <router-link
              :to="{
                name: 'products',
                query: { category: slug, order: item.value },
              }"
            >{{ item.label }}</router-link>
          </el-option>
        </el-select>
      </div>

      <div class="flex flex-row">
        <!-- <div class> -->
        <a
          class="block text-md p-1"
          @click="layout = 'grid'"
          :class="{ active: layout == 'grid' }"
          title="Grid"
        >
          <img class="h-6 w-6 cursor-pointer" src="../../assets/images/grid.svg" alt="Grid Icon" />
        </a>
     
        <a
          class="block text-md p-1"
          @click="layout = 'list'"
          :class="{ active: layout == 'list' }"
          title="List"
        >
          <img class="h-6 w-6 cursor-pointer" src="../../assets/images/list.svg" alt="List Icon" />
        </a>
    
      </div>
    </div>
    <!--/Sort, Grid - List icons -->

    <div class="flex w-1/5">
      <div class="w-full bg-white-500 h-12"></div>
    </div>
    <div v-show="windowWidth <= 990">
      <!-- <button @click="isOpen = !isOpen" class="px-3 py-2 rounded">
        <i class="fa fa-filter"></i>
      </button>-->
      <SidebarIcon />
      <SidebarMobile />
    </div>
    <div class="flex flex-wrap md:-mx-4 lg:-mx-4 px-2">
      <!-- Sidebar -->
      <div
        v-show="windowWidth >= 990"
        class="lg:w-1/6 xl:1/6 md:w-1/6 h-full mg:pl-4 md:pl-4 sm:flex"
        :key="this.$route.params.slug"
      >
        <Sidebar />
      </div>
      <!--/Sidebar -->

      <div class="flex center-400 flex-wrap md:w-5/6 lg:pl-10 md:pl-40 my-2">
        <ul v-if="layout === 'grid'" class="w-full">
          <!-- <router-view :key="this.$route.params.slug"> -->
          <ProductGrid :products="products" />
          <!-- </router-view> -->
        </ul>

        <ul v-if="layout === 'list'" class="w-full">
          <!-- <router-view :key="this.$route.params.slug"> -->
            
          <ProductList :products="products" />
          <!-- </router-view> -->
        </ul>
        <div class="inline-flex pt-10">
          <button
            class="bg-teal-400 h-10 font-semibold text-white px-2 hover:text-teal-400 hover:bg-white"
            @click="prevPage()"
          >{{ $t("Prev") }}</button>
          <p class="text-center text-teal-400 font-semibold p-3">{{ currentPage }} / {{ lastPage }}</p>
          <button
            class="bg-teal-400 h-10 font-semibold text-white px-2 hover:text-teal-400 hover:bg-white"
            @click="nextPage()"
          >{{ $t("Next") }}</button>
        </div>
      </div>
      <div class="py-4">
        <span v-html="categoryContent"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "../partials/sidebar/Sidebar.vue";
import SidebarIcon from "../partials/sidebar/SidebarIcon.vue";
import SidebarMobile from "../partials/sidebar/SidebarMobile.vue";
import ProductGrid from "../product/ProductGrid.vue";
import ProductList from "../product/ProductList.vue";
import axios from "axios";

// import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Sidebar,
    SidebarIcon,
    SidebarMobile,
    ProductGrid,
    ProductList,
  },
  data() {
    return {
      products: [],
      layout: "grid",
      currentPage: "",
      lastPage: "",
      prevUrl: "",
      nextUrl: "",
      path: "",
      slug: this.$route.query.category,
      search: this.$route.query.q,
      min_price: this.$route.query.min_price,
      max_price: this.$route.query.max_price,
      brand: this.$route.query.brand,
      newCategory: "",
      options: [
        { value: "Niedriger-Hoher", label: "Niedriger - Höherer Preis" },
        { value: "Hoher-Niedriger", label: "Höherer - Niedriger Preis" },
        { value: "A-Z", label: "A - Z Bestellung" },
        { value: "Z-A", label: "Z - A Bestellung" },
      ],
      value: "",

      windowWidth: window.innerWidth,
      txt: "",

      first: "",
      last: "",
      categoryContent: "",
    };
  },
  computed: {
    category() {
      return this.$route.query;
    },
  },

  watch: {
    category() {
      this.slug = this.$route.query.category;
      this.search = this.$route.query.q;
      this.min_price = this.$route.query.min_price;
      this.max_price = this.$route.query.max_price;
      this.brand = this.$route.query.brand;

      this.getCategoryContent();


      if(localStorage.getItem('access_token')) {
        this.getAuthData();
      }
      else {
        this.getData();
      }
    },

    windowWeight(newValue, old) {
      this.txt = `it changed to ${newValue} from ${old}`;
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  created() {
    if(localStorage.getItem('access_token')) {
      this.getAuthData();
    }
    else {
      this.getData();
    }
    this.getCategoryContent();
  },

  methods: {
    prevPage() {
      axios.get(`${this.prevUrl}`).then((response) => {
        this.products = response.data.data;
        this.currentPage = response.data.meta.current_page;
        // this.pages = response.data.meta.total;
        this.lastPage = response.data.meta.last_page;
        this.nextUrl = response.data.links.next;
        this.prevUrl = response.data.links.prev;
        // console.log(this.nextUrl);
        // console.log(this.prevUrl);
        // console.log(this.lastPage);
      });
    },

    nextPage() {
      axios.get(`${this.nextUrl}`).then((response) => {
        this.products = response.data.data;
        this.currentPage = response.data.meta.current_page;
        // this.pages = response.data.meta.total;
        this.lastPage = response.data.meta.last_page;
        this.nextUrl = response.data.links.next;
        this.prevUrl = response.data.links.prev;
      });
    },

    getData() {
      if (this.search) {
        this.url = `${process.env.VUE_APP_API}/search?q=${this.$route.query.q}`;
      } 
      else if(this.slug === 'sale') {
        // console.log('sale category');
        this.url = `${process.env.VUE_APP_API}/sale-products`;
        
        if (this.$route.query.min_price != undefined) {
          this.url += `?min_price=${this.$route.query.min_price}`;
        }
        if (this.$route.query.max_price != undefined) {
          this.url += `&max_price=${this.$route.query.max_price}`;
        }
        if (this.$route.query.brand != undefined) {
          this.url += `&brand=${this.$route.query.brand}`;
        }

      }
      else {
        this.url = `${process.env.VUE_APP_API}/products?category=${this.slug}`;
        if (this.$route.query.min_price != undefined) {
          this.url += `&min_price=${this.$route.query.min_price}`;
        }
        if (this.$route.query.max_price != undefined) {
          this.url += `&max_price=${this.$route.query.max_price}`;
        }
        if (this.$route.query.brand != undefined) {
          this.url += `&brand=${this.$route.query.brand}`;
        }
        if (this.$route.query.order == "Niedriger-Hoher") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("Niedriger-Hoher");
        }
        if (this.$route.query.order == "Hoher-Niedriger") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("Hoher-Niedriger");
        }
        if (this.$route.query.order == "A-Z") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("A-Z");
        }
        if (this.$route.query.order == "Z-A") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("Z-A");
        }

        // console.log(this.slug);
      }
      axios
        .get(this.url)
        .then((response) => {
          this.products = response.data.data;
          this.currentPage = response.data.meta.current_page;
          // this.pages = response.data.meta.total;
          this.lastPage = response.data.meta.last_page;
          this.nextUrl = response.data.links.next;
          this.prevUrl = response.data.links.prev;
          this.path = response.data.meta.path;
          this.first = response.data.links.first;
          this.last = response.data.links.last;

          // console.log(this.products);
          // console.log(this.nextUrl);
          // console.log(this.prevUrl);
          // console.log(this.lastPage);
        })
        .catch((error) => console.log(error));
    },

    getAuthData() {

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (this.search) {
        this.url = `${process.env.VUE_APP_API}/search?q=${this.$route.query.q}`;
      } 
      else if(this.slug === 'sale') {
        // console.log('sale category');
        this.url = `${process.env.VUE_APP_API}/sale-products`;

        if (this.$route.query.min_price != undefined) {
          this.url += `?min_price=${this.$route.query.min_price}`;
        }
        if (this.$route.query.max_price != undefined) {
          this.url += `&max_price=${this.$route.query.max_price}`;
        }
        if (this.$route.query.brand != undefined) {
          this.url += `&brand=${this.$route.query.brand}`;
        }
      }
      else {
        this.url = `${process.env.VUE_APP_API}/aproducts?category=${this.slug}`;
        if (this.$route.query.min_price != undefined) {
          this.url += `&min_price=${this.$route.query.min_price}`;
        }
        if (this.$route.query.max_price != undefined) {
          this.url += `&max_price=${this.$route.query.max_price}`;
        }
        if (this.$route.query.brand != undefined) {
          this.url += `&brand=${this.$route.query.brand}`;
        }
        if (this.$route.query.order == "Niedriger-Hoher") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("Niedriger-Hoher");
        }
        if (this.$route.query.order == "Hoher-Niedriger") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("Hoher-Niedriger");
        }
        if (this.$route.query.order == "A-Z") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("A-Z");
        }
        if (this.$route.query.order == "Z-A") {
          this.url += `&order=${this.$route.query.order}`;
          // console.log("Z-A");
        }

        // console.log(this.slug);
      }
      axios
        .get(this.url)
        .then((response) => {
          this.products = response.data.data;
          this.currentPage = response.data.meta.current_page;
          // this.pages = response.data.meta.total;
          this.lastPage = response.data.meta.last_page;
          this.nextUrl = response.data.links.next;
          this.prevUrl = response.data.links.prev;
          this.path = response.data.meta.path;
          this.first = response.data.links.first;
          this.last = response.data.links.last;

          // console.log(this.products);
          // console.log(this.nextUrl);
          // console.log(this.prevUrl);
          // console.log(this.lastPage);
        })
        .catch((error) => console.log(error));

      // console.log(localStorage.getItem('access_token'));
    },

    getCategoryContent() {
      axios
        .get(`${process.env.VUE_APP_API}/homepage-texts`)
        .then((response) => {
          response.data.data.map((item) => {
            if (item.name === this.$route.query.category) {
              this.categoryContent = item.description;
              // console.log(this.categoryContent);
            }
          });
        });
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>

@media(max-width:450px){
  .center-400{
    display: flex;
    justify-content: center;
  }
}

</style>